"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStorageSync = exports.shouldBeOptimized = exports.shouldAddPt = void 0;
var constants_1 = require("../../utils/constants");
/**
 * Checks if impressions previous time should be added or not.
 */
function shouldAddPt(settings) {
    return [constants_1.PRODUCER_MODE, constants_1.STANDALONE_MODE, constants_1.CONSUMER_PARTIAL_MODE].indexOf(settings.mode) > -1 ? true : false;
}
exports.shouldAddPt = shouldAddPt;
/**
 * Checks if it should dedupe impressions or not.
 */
function shouldBeOptimized(settings) {
    if (!shouldAddPt(settings))
        return false;
    return settings.sync.impressionsMode === constants_1.OPTIMIZED ? true : false;
}
exports.shouldBeOptimized = shouldBeOptimized;
/**
 * Storage is async if mode is consumer or partial consumer
 */
function isStorageSync(settings) {
    return [constants_1.CONSUMER_MODE, constants_1.CONSUMER_PARTIAL_MODE].indexOf(settings.mode) === -1 ? true : false;
}
exports.isStorageSync = isStorageSync;
